import React from "react";
import { Link, Redirect } from "react-router-dom";
import { useAuthentication } from "../auth-provider/AuthProvider";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";

const benefits = [
  {
    icon: <RestaurantMenuIcon color="primary" />,
    text: "Digital menu in minutes",
  },
  { icon: <QrCodeIcon color="primary" />, text: "QR codes for every table" },
  {
    icon: <PointOfSaleIcon color="primary" />,
    text: "Orders straight to your kitchen",
  },
];

export const DashboardLanding = () => {
  const { isLoggedIn } = useAuthentication();

  return (
    <>
      {isLoggedIn && <Redirect to={"/dashboard/menu"} />}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="calc(100vh - 60px)"
        px={2}
      >
        <Paper
          elevation={4}
          sx={{ maxWidth: 480, width: "100%", borderRadius: 3, p: 5 }}
        >
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
            Your restaurant, online in minutes
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            align="center"
            sx={{ mb: 4 }}
          >
            QR menus, table ordering, and kitchen display — all in one place.
          </Typography>

          <Stack spacing={1.5} sx={{ mb: 4 }}>
            {benefits.map(({ icon, text }) => (
              <Box key={text} display="flex" alignItems="center" gap={1.5}>
                {icon}
                <Typography variant="body2" color="text.secondary">
                  {text}
                </Typography>
              </Box>
            ))}
          </Stack>

          <Stack spacing={1.5}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => window.open("signup/", "_self")}
            >
              Get started for free
            </Button>
            <Button
              variant="outlined"
              size="large"
              fullWidth
              component={Link}
              to="/login"
            >
              Log in
            </Button>
          </Stack>
        </Paper>
      </Box>
    </>
  );
};
